import { PostCheckoutAuthSignInTrigger, TriggerHandler } from "../types";

/**
 * This is dependant upon the legacy charge api endpoint, which will be deprecated at some point
 * It's used in storyblok
 * */
export const authSignInHandler: TriggerHandler<PostCheckoutAuthSignInTrigger> = async (
  _api,
  context,
  _trigger,
) => {
  const { firstOrder } = context.sources;

  if (!firstOrder?.authData) {
    return false;
  }

  const { accessToken, refreshToken } = firstOrder.authData;

  if (accessToken && refreshToken) {
    await context.auth.forceLogin({
      access_token: accessToken,
      refresh_token: refreshToken,
      expires_in: firstOrder.authData.expiresIn,
      token_type: "Bearer",
    }, true);
    return true;
  }

  return false;
};
